export default class Paginator {
	public currentPage!: number;
	public elementsPerPage!: number;
	public totalElements!: number;
	public pageCount!: number;

	public reset(): void {
		this.currentPage = 0;
	}

	public clone(): Paginator {
		return new Paginator(this.currentPage, this.elementsPerPage, this.totalElements);
	}

	public incrementPage(): void {
		this.currentPage++;

		if (this.currentPage === this.pageCount) {
			this.currentPage = 0;
		}
	}

	public decrementPage(): void {
		this.currentPage--;

		if (this.currentPage < 0) {
			this.currentPage = this.pageCount - 1;
		}
	}

	public updateTotalElements(newTotalElements: number): void {
		this.totalElements = newTotalElements;
		this.pageCount = Math.ceil(this.totalElements / this.elementsPerPage);
	}

	public get start(): number {
		return this.currentPage * this.elementsPerPage;
	}

	public get end(): number {
		return this.start + this.elementsPerPage;
	}

	public constructor(currentPage: number, elementsPerPage: number, totalElements: number) {
		this.currentPage = currentPage;
		this.elementsPerPage = elementsPerPage;
		this.totalElements = totalElements;
		this.pageCount = Math.ceil(this.totalElements / this.elementsPerPage);
	}
}
